import { useFlag } from '@calendly/feature-check-react'
import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { ArrowRightFillIcon } from '@calendly/ui/components/icons'
import { Popup, Body, Footer } from '@calendly/ui/components/popup'

import {
  Subtext,
  ReasonButton,
} from './styles'

const ReasonOption = ({ onChooseReason, reason, reasonType }) => (
  <ReasonButton
    onClick={() => onChooseReason(reason, reasonType)}
  >
    {reason}
    <ArrowRightFillIcon />
  </ReasonButton>
)

// i18n-tasks-use t("booking.abuse_reports.#{abuseTypeOptions}.#{selectedType}")
const ReasonOptions = ({ abuseTypeVersion, abuseTypeOptions, onChooseReason }) => (
  <>
    {abuseTypeOptions.map((type) => (
      <ReasonOption
        key={type}
        onChooseReason={onChooseReason}
        reason={I18n.t(`publisher.abuse_reporting.reason_modal.${abuseTypeVersion}.${type}`)}
        reasonType={type}
      />
    ))}
  </>
)

export const ReportReasonModal = ({
  onChooseReason,
  onClose
}) => {
  const abuseReportEnhancementsEnabled = useFlag('trust_and_safety_abuse_reports_enhancements')
  const abuseTypesV1 = ['unknown_invitee', 'unwelcome_invitee', 'spam', 'harassment', 'something_else']
  const abuseTypesV2 = ['spam', 'harassment', 'scam', 'no_show_or_unwelcome', 'something_else']
  const abuseTypeOptions = abuseReportEnhancementsEnabled ? abuseTypesV2 : abuseTypesV1
  const abuseTypeVersion = abuseReportEnhancementsEnabled ? 'options_v2' : 'options'

  return (
    <Popup
      title={I18n.t('publisher.abuse_reporting.reason_modal.title')}
      onClose={onClose}
    >
      <Body isInverse>
        <Subtext>{I18n.t('publisher.abuse_reporting.reason_modal.subtext')}</Subtext>
        <ReasonOptions abuseTypeVersion={abuseTypeVersion} abuseTypeOptions={abuseTypeOptions} onChooseReason={onChooseReason} />
      </Body>
      <Footer>
        <Button
          wide
          decoration="secondary-outline"
          onClick={onClose}
        >
          {I18n.t('publisher.action.nevermind')}
        </Button>
      </Footer>
    </Popup>
  )
}
